<div class="fdx-u-mt--7 fdx-u-mb--5 fdx-u-color--grey--dark-1">
    <h1 class="fdx-c-header fdx-c-header--h2 fdx-u-fontweight--normal" id="contactTitle" aria-atomic="true"
        aria-live="assertive">
        {{ 'contact.header' | translate }}
    </h1>
</div>

<hr class="fdx-c-line fdx-c-line--grey--light-4" aria-atomic="true" aria-live="assertive">

<div class="fdx-o-grid__row fdx-u-mt--4 fdx-u-mb--0@small-only fdx-u-mt--0@small-only">
    <div class="fdx-o-grid__item--10">
        <h2 class="fdx-u-font-size--h4 fdx-u-text--light fdx-u-mb--0@small-only fdx-u-mr--6@small-only" id="contactSubTitle" aria-atomic="true"
            aria-live="assertive">
            {{ 'contact.subHeader' | translate }}
        </h2>
    </div>
<ng-container>
    <div class="fdx-o-grid__item--2 fdx-u-align--right fdx-u-mt--1" routerLinkActive #rla="routerLinkActive" [hidden]="rla.isActive">
        <a id="edit-btn" [routerLink]="'edit'" routerLinkActive="active"
            class="fdx-c-button fdx-c-button--text fdx-u-pr--0 fdx-u-pl--0 fdx-u-pt--0 fdx-u-pb--0"
            aria-atomic="true" aria-live="assertive">
            {{ 'contact.edit' | translate }}
       </a>
    </div>
</ng-container>

</div>


<router-outlet></router-outlet>
